<template>
  <div ref="formContainer">
    <slot :handleInputError="handleInputError" :checkInputError="scrollToLastErrorField"/>
  </div>
</template>

<script>
export default {
  props: {
    formName: {
      type: String,
    },
    action: {
      type: Function,
      default: () => false
    }
  },
  data() {
    return {
      inputErrors: {},
      lastErrorField: '',
      actionResult:'',
      inputPercentages: {}
    };
  },
  computed: {
    hasErrors() {
      return Object.values(this.inputErrors).some(error => error);
    }
  },
  methods: {
    handleInputError({ hasError, name, percent }) {
      this.inputErrors[name] = { key: name, error: hasError };
      let keysArray = Object.keys(this.inputErrors);
      let numberOfElements = keysArray.length;
      this.$emit('inputErrors', {
        hasError: this.hasErrors,
        formName: this.formName,
        quantity: numberOfElements,
        orderPercent: percent
      });
      this.inputPercentages[name] = parseInt(percent, 10);
      const overallCompletionPercentage = Object.values(this.inputPercentages).reduce((total, currentPercent) => {
        return total + currentPercent;
      }, 0);

      const finalOverallCompletionPercentage = Math.max(0, overallCompletionPercentage);
      this.$emit('overallCompletion', finalOverallCompletionPercentage);
    },
    doSomeAction(status) {
      if (status == true) {
        if (typeof this.action === 'function') {
          return this.action();
        }
      } else {
        return status;
      }
    },
    scrollToLastErrorField() {
      if (this.hasErrors) {
        const errorFields = Object.keys(this.inputErrors).filter(key => this.inputErrors[key].error);
        const lastErrorField = errorFields[errorFields.length - 1];
        if (errorFields.length > 0) {
          const element = this.$refs.formContainer.querySelector(`[name="${lastErrorField}"]`);
          if (element) {
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            });
            const event = new Event('blur');
            element.dispatchEvent(event);
            this.actionResult = this.doSomeAction(false);
          }
        } else {
          this.actionResult = this.doSomeAction(true);
        }
      }

      const event = new CustomEvent('response', {
        detail: {
          formName: this.formName,
          result: this.actionResult
        }
      });
      this.$el.dispatchEvent(event);
    },
  }
};
</script>

<style scoped>
/* Ваши стили */
</style>
